import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { QueryParametersPayload } from '@old/typed/extra/service.types';

type ReportId = string;
type Payload = QueryParametersPayload<ReportId>;

export const getReportSatViewByIdService = async ({ query: rawQuery }: Payload) => {
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.BLOB.get<Blob>(ENDPOINT.REPORT_SAT_V2, { query });
  return {
    response,
    summary: data,
  };
};
